import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

export const getList = (data,info) => {
  return axios.request({
    url: `${urlObj.wss}wss-part/activity/activityList?current=${info.page}&&size=${info.size}`,
    method: 'post',
    data
  })
}
export const getDetail = (data,info) => {
  return axios.request({
    url: `${urlObj.wss}wss-part/activity/queryDetails?current=${info.page}&&size=${info.size}`,
    method: 'post',
    data
  })
}